// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".misspelled {\n  border-bottom: 2px solid;\n  padding: 2px;\n  display: inline-block;\n  background-color: #fdefef;\n  border-bottom-color: #f63842;\n}\n.misspelled.hard {\n  border-bottom-color: #f63842;\n  background-color: #fdefef;\n}\n.misspelled.soft {\n  border-bottom-color: #ffab00;\n  background-color: #fef7ef;\n}\n", ""]);
// Exports
module.exports = exports;
